const EMAIL_ROUTES = {
    SEND_EMAIL_TEXT: `email/text/notification`,
    SEND_EMAIL_FILE: `email/file/notification`,
};

export default EMAIL_ROUTES;
